import { Link } from "react-router-dom";
import { buttonClass, Card } from "@promptgatewaysadmin/ui";
import { CHROME_WEB_STORE_URL } from "../config.js";
import { useOptionalSession } from "../auth/SessionProvider.js";
import { readFunnel } from "../auth/persistence.js";

/**
 * /onboarding
 *
 * Deliberately does NOT require an org: it is where a team signup lands after the
 * org is created, and installing the extension is free and useful regardless of plan.
 *
 * "I'll do this later" is a real, unpenalised exit. An onboarding step that cannot be
 * skipped is a step that gets faked.
 */
export function Onboarding() {
  const session = useOptionalSession();
  const funnel = readFunnel();
  const next = funnel.plan ? `/checkout?plan=${funnel.plan}&interval=${funnel.interval ?? "month"}` : "/";

  return (
    <div className="pg-page">
      <h1>Install the extension</h1>
      <p>
        Prompt Gateway works inside the tools you already use. Install it once and it&apos;s
        available everywhere.
      </p>

      <Card title="1 · Add it to your browser">
        <p className="pg-card__body">
          Chrome, Edge and Brave. Takes about ten seconds.
        </p>
        <a
          className={buttonClass("primary")}
          href={CHROME_WEB_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Get the extension
        </a>
      </Card>

      <Card title="2 · Sign in with this account">
        <p className="pg-card__body">
          Open the extension and sign in as{" "}
          <strong>{session?.me.email ?? "your account"}</strong>. Your plan, policy and team
          come with you.
        </p>
      </Card>

      <Card title="3 · Press the shortcut anywhere">
        <p className="pg-card__body">
          Highlight a prompt and press the shortcut. Nothing you type is stored — the
          enhancement happens in flight.
        </p>
      </Card>

      <div className="pg-onboarding__actions">
        <Link className={buttonClass("secondary")} to="/">
          I&apos;ll do this later
        </Link>
        {funnel.plan && (
          <Link className={buttonClass("primary")} to={next}>
            Continue
          </Link>
        )}
      </div>
    </div>
  );
}
